<template>
  <div id="sp-content">
    <div id="shousai-content">
      <div
        id="sp-shousai-inner"
        class="mb10"
        :style="`background: url(${userRealIntentionImageUrlForSp}/back.png`"
      >
        <div class="honne_box mb30">
          <div class="data_box mb30 tc preview-clearfix">
            <div class="human">
              <div class="tc fll">
                <img
                  :src="`${userRealIntentionIconImageUrlForSp}`"
                  data-test="icon-url"
                >
              </div>
            </div>
            <div class="profile w60 tl fs12 fll">
              <div class="profile_inner preview-clearfix">
                <p class="fs11 mb5 tr">
                  回答日 <span data-test="answer-date">{{ realIntention.createDate | formatDate }}</span>
                </p>
                <p>
                  <span data-test="content">{{ content }}</span>
                </p>
              </div>
            </div>
          </div>
          <div class="arrow_box">
            <ul
              id="question"
              :style="`background: url(${userRealIntentionImageUrlForSp}/q.png) no-repeat;background-position: 13px 13px; background-size: 20px; padding: 15px 15px 0 20px;`"
            >
              <li
                class="fs12"
                data-test="question1"
              >
                1．あなたの会社はどんな会社だと思う？
              </li>
              <li
                class="fs12"
                data-test="question2"
              >
                2．会社の一番良いところは？
              </li>
              <li
                class="fs12"
                data-test="question3"
              >
                3．会社に期待していることは？
              </li>
            </ul>
            <ul
              id="answer"
              class="pega-pre-wrap"
            >
              <li class="mt25 fs13">
                <span class="fll">1．</span>
                <p
                  data-test="answer1"
                  v-text="realIntention.question1"
                />
              </li>
              <li class="mt25 fs13">
                <span class="fll">2．</span>
                <p
                  data-test="answer2"
                  v-text="realIntention.question2"
                />
              </li>
              <li class="mt25 fs13">
                <span class="fll">3．</span>
                <p
                  data-test="answer3"
                  v-text="realIntention.question3"
                />
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="space-18px">
      &nbsp;
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
@use "@/styles/preview/sp/realintention/_base" as *;
</style>

<script>
import dayjs from 'dayjs'
import _ from 'lodash'

const USER_URL = process.env.USER_ENDPOINT

export default {
  filters: {
    formatDate (val) {
      return val ? dayjs(val).format('YYYY.M') : ''
    }
  },
  data () {
    return {
      realIntention: {}
    }
  },
  computed: {
    userRealIntentionImageUrlForSp: () => `${USER_URL}/th/sp/img/realintention`,
    userRealIntentionIconImageUrlForSp () {
      if (_.isEmpty(this.realIntention)) return
      return `${this.userRealIntentionImageUrlForSp}/${this.realIntention.icon}`
    },
    content () {
      if (_.isEmpty(this.realIntention)) return
      return [
        this.realIntention.post,
        this.realIntention.gender.name,
        this.realIntention.age ? `${this.realIntention.age}歳` : '',
        this.realIntention.serviceYear ? `${this.realIntention.serviceYear}年目` : ''
      ].filter(v => v).join(' / ').concat(this.realIntention.career.name ? ` (${this.realIntention.career.name}入社)` : '')
    }
  },
  created () {
    this.fetch()
  },
  methods: {
    fetch () {
      this.$http.secured.get(`/real_intention/real_intentions/${this.$route.params.id}`).then(response => {
        this.$set(this, 'realIntention', response.data)
      })
    }
  }
}
</script>
